import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_warehouse_layout_node_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    layout_hdr_guid: fromDatatype.GuidDataFieldInterface;
    node_type_guid: fromDatatype.GuidDataFieldInterface;
    is_leaf: boolean;
    note_type_code: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    level: fromDatatype.IntegerDatatypeInterface;
    pos_x: fromDatatype.NumericDatatypeInterface;
    pos_y: fromDatatype.NumericDatatypeInterface;
    pos_z: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_max_weight: fromDatatype.NumericDatatypeInterface;
    no_children: fromDatatype.IntegerDatatypeInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    scan_code_type: fromDatatype.VarcharDatatypeInterface;
    scan_code_image: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wms_warehouse_layout_node_hdr_RowClass implements bl_wms_warehouse_layout_node_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_guid: fromDatatype.GuidDataFieldInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    layout_hdr_guid: fromDatatype.GuidDataFieldInterface;
    node_type_guid: fromDatatype.GuidDataFieldInterface;
    is_leaf: boolean;
    note_type_code: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    level: fromDatatype.IntegerDatatypeInterface;
    pos_x: fromDatatype.NumericDatatypeInterface;
    pos_y: fromDatatype.NumericDatatypeInterface;
    pos_z: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_max_weight: fromDatatype.NumericDatatypeInterface;
    no_children: fromDatatype.IntegerDatatypeInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    scan_code_type: fromDatatype.VarcharDatatypeInterface;
    scan_code_image: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}